import { useJourney } from "../../core/utils/hooks/useJourney"
import { useUsers } from "../../core/utils/hooks/useUsers"
import ProducersJourneyScreen from "../../screen/ProducersJourneyScreen"

const ProducersJourneyContainer = () => {
  const { users } = useUsers();
  const { journey } = useJourney();

  return (
    <ProducersJourneyScreen
      {...{
        journey,
        users,
      }}
    />
  )
}

export default ProducersJourneyContainer
